export default __webpack_public_path__ + "static/media/Batuhan.bdd99fbf.jpeg";